module.exports = __webpack_public_path__ + "img/plugin1.756937e8.png";